//chapter1
export default {
    id : 9,//chapter number
    title : '09. DFMEA 작성방법 (2) - DFMEA 구조분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c09.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA 구조분석',
            ],
            body2 : [
                'DFMEA 구조분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '09.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '구조분석에서 Focus element는 고장형태 정의 핵심대상이다.',//html available
                    answer : "1",
                    explain : '고장형태 정의의 출발점이다.'
                },
                {
                    type : 'ox',
                    question : 'Block/Boundary Diagram은 기능분석의 도구다.',//html available
                    answer : "2",
                    explain : 'Block/Boundary Diagram은 구조분석의 도구이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 관련 시스템과 구조식별</h3>
                        <li>시스템 FMEA, 구성품 FMEA</li>
                        <p class="mg10"></p>
                        <h3>2. 시스템 구조의 시각화</h3>
                        <li>STRUCTURE TREE, BLOCK BOUNDRY DIAGRAM 작성방법</li>
                        <li>주의 사항 및 사례</li>
                        <p class="mg10"></p>
                        <h3>3. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c09.mp4',
        },
    ]
}